import useI18n from '@/hooks/useI18n';
import { Button, ButtonProps, Drawer, DrawerProps, Space } from 'antd';
import { forwardRef, useImperativeHandle, useState } from 'react';

interface propsType extends DrawerProps {
  onOk: () => void;
  okText?: any;
  canSubmitClose?: boolean; // 是否在点击submit的时候直接关闭弹框
  beforeClose?: () => void; // 兼容自定义处理一些关闭事件
  afterOpenChange?: () => void; // 兼容自定义处理一些打开事件
  submitProps?: ButtonProps;
}

const CommonDrawer = (props: propsType, ref: any) => {
  const {
    onOk,
    okText,
    canSubmitClose,
    beforeClose,
    afterOpenChange,
    submitProps = {},
    ...resetProps
  } = props;
  const [open, setOpen] = useState(false);
  const { formatMessage } = useI18n();

  const onOpen = () => setOpen(true);
  const onClose = () => {
    beforeClose?.();
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    onOpen,
    onClose, // close是为了兼容某些不需要关闭弹框的场景
  }));

  return (
    <Drawer
      open={open}
      onClose={onClose}
      destroyOnClose
      maskClosable={false}
      afterOpenChange={afterOpenChange}
      footer={
        <Space size={8} style={{ float: 'right' }}>
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              onOk?.();
              if (canSubmitClose) {
                onClose();
              }
            }}
            {...submitProps}
          >
            {okText || formatMessage('common.submit')}
          </Button>
          <Button key="cancel" onClick={onClose}>
            {formatMessage('common.cancel')}
          </Button>
        </Space>
      }
      // contentWrapperStyle={{ top: 60 }}
      {...resetProps}
    >
      {props.children}
    </Drawer>
  );
};
export default forwardRef(CommonDrawer);
